export const STEPS = {
  EMAIL: 'email',
  EMAIL_OTP: 'emailOtp',
  PHONE: 'phone',
  PHONE_OTP: 'phoneOtp',
  DONE: 'done'
};
